"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPillUrlWithDataset = exports.getPillURL = exports.getPillDataset = exports.getPillData = exports.getPill = void 0;

var _config = require("./config");

var _params = require("./params");

var _iframe = require("./iframe");

var _substitutions = require("./substitutions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var V1_PILLS = ['contrata-un-fondo-evo'];

var getPillUrlWithDataset = function getPillUrlWithDataset(dataset) {
  switch (dataset.version) {
    case 1:
      return "".concat(_config.PILLS_V1_BASEURL, "/").concat(dataset.id, "-").concat(dataset.partner);

    case 2:
    default:
      return "".concat(_config.PILLS_V2_BASEURL, "/").concat(dataset.lang, "/").concat(dataset.consumer, "/").concat(dataset.theme, "/").concat(dataset.id);
  }
};

exports.getPillUrlWithDataset = getPillUrlWithDataset;

var getPillURL = function getPillURL(pillUrl) {
  var DEFAULT_BASE_URL = 'https://www.finect.com/pills/es_ES/finect/default';

  if (pillUrl.substring(0, 2) === '//') {
    return "https:".concat(pillUrl);
  } else if (pillUrl.charAt(0) === '/') {
    return window.location.origin + pillUrl;
  } else if (pillUrl.substring(0, 4) !== 'http') {
    return DEFAULT_BASE_URL + pillUrl;
  }

  return pillUrl;
};

exports.getPillURL = getPillURL;

var getPillData = function getPillData(pillUrl) {
  var pillV1Data = pillUrl.match(_config.PILLS_V1_PATTERN);

  if (pillV1Data && pillV1Data.length) {
    return {
      url: pillV1Data[0],
      // origin: pillV1Data[1],
      // Esto está hecho así para que funcionen los postMessages
      // desde el window dónde está insertado el pillbuilder hasta GTM
      // las píldoras de F1 que se han sustituido por el F2 con una redirección 301
      // ternario para validar si la pill no tiene sustitución y no cambiar el origen
      origin: V1_PILLS.includes(pillV1Data[2]) ? pillV1Data[1] : 'https://www.finect.com',
      id: pillV1Data[2],
      version: 1
    };
  }

  var pillV2Data = pillUrl.match(_config.PILLS_V2_PATTERN);

  if (pillV2Data && pillV2Data.length) {
    return {
      url: pillV2Data[0],
      origin: pillV2Data[1],
      id: pillV2Data[2],
      version: 2
    };
  }

  return null;
};

exports.getPillData = getPillData;

var getPill = function getPill(requestPillUrl, dataset) {
  var additionalParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var pillData = getPillData(requestPillUrl);
  var pillId = pillData.id.split('?')[0];
  var substitutionPill = (0, _substitutions.getSubstitution)(pillData.id, pillData.version);
  var pillUrl = substitutionPill ? getPillUrlWithDataset(_objectSpread(_objectSpread({}, dataset), {
    version: substitutionPill.version,
    id: substitutionPill.id
  })) : requestPillUrl;
  var iframeId = _config.IFRAME_ID_PREFIX + pillId;
  var iframeCustomAttributes = (0, _params.getAttributesByPrefix)('attr', dataset);
  var iframeParams = (0, _params.getAttributesByPrefix)('param', dataset);
  var iframeAttributes = (0, _iframe.getIframeAttributes)(pillUrl, pillId, iframeCustomAttributes);
  var pillReferrer = dataset.referrer ? dataset.referrer : document.location.href;
  return {
    origin: pillData.origin,
    pillId: pillId,
    iframeAttributes: _objectSpread(_objectSpread({}, iframeAttributes), {}),
    iframeCustomAttributes: _objectSpread(_objectSpread({}, iframeCustomAttributes), additionalParams),
    iframeParams: _objectSpread(_objectSpread({}, iframeParams), {}),
    iframeId: iframeId,
    referrer: pillReferrer,
    version: dataset.version || null,
    additionalParams: additionalParams,
    dataset: dataset,
    inputMessages: []
  };
};

exports.getPill = getPill;

var getPillDataset = function getPillDataset(dataset) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return {
    pill: dataset.pill,
    theme: dataset.theme || 'default',
    consumer: dataset.consumer || 'finect',
    partner: dataset.partner || 'finectblog',
    lang: dataset.language || 'es_ES',
    id: dataset.id || null,
    version: version
  };
};

exports.getPillDataset = getPillDataset;